import { useClerk } from "@clerk/react";
import { Botao } from "@/components/casca/formulario";

export function BotaoSair() {
  const { signOut } = useClerk();
  return (
    <Botao variante="secundario" icone="sair" onClick={() => void signOut({ redirectUrl: "/sign-in" })}>
      Sair da conta
    </Botao>
  );
}
